<template>
    <div class="cus-radio flex flex-mid flex-center" @click="value_ = radioData_.id" :class="value_ == radioData_.id?'cus-sel':''">
        {{radioData_.name}}


    </div>
</template>

<script>
    export default {
        name: "CustomerRadio",
        props:['value','radio-data'],
        data(){
            return{
                value_:this.value,
                radioData_:this.radioData
            }
        },
        watch:{
            radioData(val){
                this.radioData_ = val
            },
            value_(val){
                this.$emit('input',val)
            },
            value(val){
                this.value_ = val
            }
        }
    }
</script>

<style scoped>

    .cus-radio{
        min-width: 150px;
        height: 36px;
        border: 1px solid #e5e5e5;
        color: #e5e5e5;
        font-size: 14px;
        padding: 0 8px;
        border-radius: 4px;

    }
    .cus-sel{
        border: 1px solid #409EFF;
        color: #409EFF;
    }
</style>


// WEBPACK FOOTER //
// src/components/CustomerRadio.vue